import ThinCross from 'components/Icons/ThinCross';
import React, { FC, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  closeToast: () => void;
  heading: string;
  backgroundColor: string;
}>;

const ToastMessage: FC<Props> = (props: Props) => {
  const { heading, backgroundColor, closeToast, children } = props;

  return (
    <div className="toast-success row w100 h100">
      <div className="color-white w100 b-2" style={{ backgroundColor }}>
        <div
          className="row justify-between"
          style={{ padding: '.5rem .5rem .25rem 1rem' }}
        >
          <div className="font-size-5 medium pt1">{heading}</div>
          <div
            className="flex-center hrem-1 wrem-1 ml1"
            onClick={(): void => closeToast()}
          >
            <ThinCross width="8px" height="8px" fill="colorWhite" />
          </div>
        </div>
        <div className="light font-size-5 px3 pb2">{children}</div>
      </div>
    </div>
  );
};

export default ToastMessage;
